import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, Validators } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';
import { Question } from 'src/app/models/question';
import { ContestService } from 'src/app/services/contest.service';
import { InputPhoneComponent } from '../input-phone/input-phone.component';

import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class FormComponent implements OnInit, OnChanges {
  @Input() questions: Array<Question> = [];

  @Input() set disabled(disabled: boolean) {
    this._disabled = disabled;
    console.debug('FormComponent.disabled', disabled, this.questions);
    this.questions.forEach((question) => {
      if (disabled) question.formControl.disable();
      else question.formControl.enable();
    });
  }

  @Output() documentChanged = new EventEmitter<void>();

  _disabled: boolean = false;

  minDate: any;

  modalOpen = false;
  currentField: any;
  specialFieldsOptions: any;

  selectedValues: { [key: string]: string[] } = {};
  currentFieldId: string = '';
  isMultipleSpecialField = false;

  modalOpenTrigger = false;

  showOtherInput: boolean = false;

  categoriesData: any
  storesData: any

  isSelectModalOpen = false;

  // city and neighborhood pagination
  limit = 20;
  offset = 0;
  loadingMore = false;
  hasMoreOptions = true

  activeQuestion: any;

  promotionalTitleShown = false;
  firstAllowPromotionalId: string | null = null;

  firstIncrementalId: string | null = null;

  constructor(
    private popoverController: PopoverController,
    private http: HttpClient, private contestSvc: ContestService
  ) {
    const today = new Date();
    const hundredYearsAgo = new Date(today.getFullYear() - 100, 0, 1);

    this.minDate = hundredYearsAgo;
  }


  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    const newQuestions: Question[] = changes['questions']?.currentValue || [];

    newQuestions.forEach((question) => {
      if (
        question.type === 'dynamic-select' &&
        question.url &&
        typeof question.url === 'string'
      ) {
        this.http.get<any>(question.url).subscribe({
          next: (data) => {
            question.options = data.results.map((item: any) => ({
              label: item.label || item.name,
              value: item.value || item.id,
            }));
          },
          error: (err) => {
            console.error(
              'Error loading dynamic options for',
              question.id,
              err
            );
          },
        });
      }

      // just for bill_number
      if (question.id === 'bill_number' && question.formControl) {
        const control = question.formControl;

        const documentNumber = (localStorage.getItem('document_number') || '')
          .replace(/\s+/g, '')
          .trim();

        control.valueChanges.subscribe((value: string) => {
          if (typeof value === 'string') {
            const trimmed = value.replace(/\s+/g, '');

            if (trimmed !== value) {
              control.setValue(trimmed, { emitEvent: false });
            }

            const errors = { ...(control.errors || {}) };

            if (trimmed && trimmed === documentNumber) {
              errors['sameAsDocument'] = true;
            } else {
              delete errors['sameAsDocument'];
            }

            control.setErrors(Object.keys(errors).length ? errors : null);
          }
        });
      }
    });

    if (changes['questions'] && this.questions?.length) {
      this.configureQuestions();
    }
  }

  /**
   * Updates the value of the given question when is date
   * @param question
   * @returns
   */
  changeDate(question: Question, event: any) {
    console.debug('FormComponent.changeDate()', question, event);
    question.formControl.setValue(event.format('YYYY-MM-DD'));
    this.popoverController.dismiss();
  }

  /**
   * Updates the value of the given question when is time
   * @param question
   * @param event
   */
  changeTime(question: Question, event: any) {
    console.debug('FormComponent.changeTime()', question, event);
    let timeValue = event.detail.value;
    console.debug('timeValue', timeValue);
    question.formControl.setValue(timeValue);
  }

  /**
   * Returns the error text for the given question
   * @param question
   * @returns
   */
   getErrorText(question: Question) {
    let formControl: FormControl = question.formControl;
    let errorText: any = question.errorText;
    const invalidDomains = ['yopmail.com'];

    if (formControl.hasError('pattern')) {
      if (errorText && errorText.pattern) return errorText.pattern;
      return 'El formato ingresado no es correcto';
    } else if (formControl.hasError('maxlength')) {
      if (errorText && errorText.maxlength) return errorText.maxlength;
      return 'El texto ingresado es demasiado largo';
    } else if (formControl.hasError('required')) {
      return 'Este campo es requerido';
    } else if (formControl.hasError('futureDate')) {
      return 'La fecha no puede ser futura';
    } else if (formControl.hasError('sameAsDocument')) {
      return 'El número de factura no puede ser igual al número de documento';
    } else if (formControl.hasError('email')) {
      return 'Debes ingresar un correo electrónico válido';
    } else if (formControl.hasError('email')) {
      return 'Debes ingresar un correo electrónico válido';
    }

    const emailValue = formControl?.value;
    if (emailValue && question.id == 'email') {
      const domain = emailValue.split('@')[1];
      if (invalidDomains.includes(domain)) {
        return 'El dominio del correo electrónico ingresado no es válido';
      }
    }

    return '';
  }

  searchQuestionOptions(
    event: { component: IonicSelectableComponent; text: string },
    question: Question
  ) {
    let text = event.text.trim().toLowerCase();
    if (!question.options) return;
    event.component.startSearch();
    // Close any running subscription.
    event.component.items = question.options?.filter((item) => {
      return (
        ('' + item.value).toLowerCase().indexOf(text) !== -1 ||
        item.label.toLowerCase().indexOf(text) !== -1 ||
        item.subLabel?.toLowerCase().indexOf(text) !== -1
      );
    });
    event.component.endSearch();
  }

  getTextSuggestions(question: Question): string[] {
    const { suggestions, formControl } = question;
    if (!suggestions || !formControl.value) {
      return [];
    }
    const value = formControl.value?.toLowerCase() || ''; // Normaliza el valor
    // Si no hay ningún @, se devuelven todas las sugerencias
    if (!value.includes('@')) {
      return [];
    }
    const [localPart, domainPart] = value.split('@'); // Separa el correo en dos partes
    // Si se ha escrito solo `@` o no hay nada después del `@`, muestra todas las sugerencias
    if (domainPart.length === 0) {
      return suggestions.slice(0, 5);
    }
    // Filtra las sugerencias si ya se empezó a escribir el dominio
    return suggestions
      .filter((suggestion) =>
        suggestion.toLowerCase().startsWith(`@${domainPart}`)
      )
      .slice(0, 5);
  }

  selectSuggestion(question: Question, suggestion: string): void {
    const { formControl } = question;
    const value = formControl.value || ''; // Obtén el valor actual del campo
    // Divide el valor en la parte antes y después del '@'
    const [localPart] = value.split('@');
    // Actualiza el valor del formControl concatenando la parte local con la sugerencia seleccionada
    formControl.setValue(`${localPart}${suggestion}`);
  }

  onChange(question: Question) {
    const billNumberControl = this.questions.find(
      (q) => q.id === 'bill_number'
    )?.formControl;

    if (billNumberControl) {
      billNumberControl.valueChanges.subscribe((value: string) => {
        const sanitized = this.sanitizeBillNumber(value || '');
        if (value !== sanitized) {
          billNumberControl.setValue(sanitized, { emitEvent: false });
        }
      });
    }
  }

  sanitizeBillNumber(value: string): string {
     return value.replace(/[^a-zA-Z0-9]/g, '');
  }

  onAutocompleteSearch(event: any, question: Question): void {
    const searchTerm = event.detail.value?.trim() || '';

    question.formControl.setValue(searchTerm, { emitEvent: false });

    let urlToUse = question.url;

    if (question.depends_on === 'city') {
      const cityQuestion = this.questions.find(q => q.id === 'city');
      const cityValue = cityQuestion!.formControl!.value;

      if (!cityValue) {
        question.filteredOptions = [];
        return;
      }

      urlToUse = question.url!.replace('{{value}}', cityValue);
    }

    if (!searchTerm || !urlToUse) {
      question.filteredOptions = [];
      question.showOptions = false;

      question.formControl.setValue(null, { emitEvent: false });

      return;
    }

    this.http.get<any>(`${urlToUse}?search=${encodeURIComponent(searchTerm)}`).subscribe({
      next: (data) => {
        question.filteredOptions = data.results.map((item: any) => ({
          label: item.label || item.name,
          value: item.value || item.id,
        }));

        question.showOptions = true;
      },
      error: (err) => {
        console.error(`Error fetching options for ${question.id}`, err);
        question.filteredOptions = [];
      },
    });
  }

  selectAutocompleteOption(option: any, question: Question): void {

    const previousValue = question.formControl.value;

    question.formControl.setValue(option.value);
    question.formControl.markAsDirty();
    question.formControl.markAsTouched();
    question.showOptions = false;

    if (question.id === 'neighborhood') {

      if (option.value === 'other') {
        this.showOtherInput = true;
      } else {
        this.showOtherInput = false;
      }
    }

    if (previousValue !== option.value) {
      this.clearDependentFields(question.id);
    }
  }

  clearDependentFields(parentId: string) {

    const children = this.questions.filter(q => q.depends_on === parentId);

    children.forEach(child => {

      child.formControl.setValue(null);
      child.filteredOptions = [];
      child.showOptions = false;

      if (child.id === 'neighborhood') {
        this.showOtherInput = false;
      }

      this.clearDependentFields(child.id);
    });
  }

  onOtherNeighborhoodInput(event: any, question: Question) {
    const value = event.detail.value;

    if (question.id === 'neighborhood') {
      question.formControl.setValue(value);
    }
  }

  onBlurAutocomplete(question: Question): void {
    setTimeout(() => {
      question.showOptions = false;
    }, 200);
  }

  getOptionLabel(question: Question): string {

    const selectedValue = question.formControl.value;

    if (!selectedValue) return '';

    if (question.id === 'neighborhood' && this.showOtherInput) {
      return 'Otro';
    }

    const option = question.filteredOptions?.find(
      (opt) => opt.value === selectedValue
    );

    return option?.label || '';
  }

  onChangeDocumentValidation(question: any) {
    if (question.id === 'document') {
      this.documentChanged.emit();
    }
  }

  noFutureDateValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
    const today = new Date();
    const inputDate = new Date(value);
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate > today) {
      return { futureDate: true };
    }

    return null;
  }

  onTimeBlur(question: Question): void {
    let value = question.formControl.value || '';
    value = value.replace(/\D/g, '');
    let formatted = '';
    if (value.length === 1) {
      formatted = `0${value}:00`;
    } else if (value.length === 2) {
      formatted = `${value}:00`;
    } else if (value.length === 3) {
      formatted = `0${value[0]}:${value.slice(1)}`;
    } else if (value.length >= 4) {
      formatted = `${value.slice(0, 2)}:${value.slice(2, 4)}`;
    }
    const valid = /^([01]\d|2[0-3]):([0-5]\d)$/.test(formatted);
    if (valid) {
      question.formControl.setValue(formatted);
    }
  }

  openFieldModalForQuestion(question: any) {
    const fieldKey = question.question_id || question.id;

    this.currentFieldId = fieldKey;

    this.currentField = {
      ...question,
      options: question.options?.map((opt: any) => opt.value ?? opt)
    };

    this.isMultipleSpecialField = question.multiple || question.type === 'multiple-select';

    const existingValue = question.formControl.value;

    this.selectedValues[fieldKey] = Array.isArray(existingValue)
      ? existingValue
      : existingValue
        ? [existingValue]
        : [];

    setTimeout(() => {
      this.modalOpenTrigger = true;
      setTimeout(() => {
        this.modalOpenTrigger = false;
      }, 100);
    });
  }

  handleSelection(selected: string[] | string) {

    if (this.currentFieldId) {

      const valuesArray = Array.isArray(selected) ? selected : [selected];

      const selectedQuestion = this.questions.find(
        q => q.question_id === this.currentFieldId || q.id === this.currentFieldId
      );

      if (selectedQuestion) {

        if (selectedQuestion.id === 'store_id') {

          const selectedValue = valuesArray[0];

          const storeFound = this.storesData?.find(
            (store: any) => store.name === selectedValue
          );

          selectedQuestion.formControl.setValue(storeFound?.store_id || null);
          selectedQuestion.formControl.markAsDirty();

          this.selectedValues[this.currentFieldId] = [storeFound?.id];

          return;
        }

        const isMultiple =
          selectedQuestion.multiple || selectedQuestion.type === 'multiple-select';

        selectedQuestion.formControl.setValue(isMultiple ? valuesArray : valuesArray[0]);

        selectedQuestion.formControl.markAsDirty();

        this.selectedValues[this.currentFieldId] = valuesArray;

      }
    }
  }

  getDisplayValue(question: any): string {
    const value = question.formControl.value;
    if (!value) return '';

    const valuesArray = Array.isArray(value) ? value : [value];
    return question.options
      .filter((opt: { value: any; }) => valuesArray.includes(opt.value))
      .map((opt: { label: any; }) => opt.label)
      .join(', ');
  }

  onMainInputChange(question: Question) {
    if (question.id === 'city') {
      question.formControl.setErrors({ invalidOption: true });
    }

    if (this.showOtherInput) {
      this.showOtherInput = false;
    }
  }


  async openStoreSelector(question: any) {
    try {
      await this.getStores();

      question.options = (this.storesData || []).map((store: any) => ({
        label: store.name,
        value: store.name
      }));

      this.openFieldModalForQuestion(question);

    } catch (error) {
      console.error('Error loading stores', error);
    }
  }

  async getStores(): Promise<any[]> {

    let data: any = await firstValueFrom(this.contestSvc.getStores());

    const newStores = data || [];

    const storeMap = new Map<number, any>();

    [...(this.storesData || []), ...newStores].forEach(store => {
      storeMap.set(store.id, store);
    });

    this.storesData = Array.from(storeMap.values());

    return newStores;
  }

  getStoreLabel(storeId: number | string) {
    if (!storeId) return '';

    const store = this.storesData?.find(
      (s: any) => s.store_id === storeId
    );

    return store ? store.name : storeId;
  }

  openDropdown(question: any) {
    this.questions.forEach(q => q.showOptions = false);

    question.showOptions = true;
    this.activeQuestion = question;

    this.offset = 0;
    this.hasMoreOptions = true;

    question.searchTerm = '';

    this.fetchOptions(question, true);
  }

  fetchOptions(question: any, reset: boolean = false) {
    let urlToUse = question.url;

    if (question.depends_on === 'city') {
      const cityQuestion = this.questions.find(q => q.id === 'city');
      const cityValue = cityQuestion?.formControl?.value;

      if (!cityValue) {
        question.filteredOptions = [];
        return;
      }

      urlToUse = question.url.replace('{{value}}', cityValue);
    }

    const search = question.searchTerm || '';

    if (reset) {
      this.offset = 0;
      question.filteredOptions = [];
    }

    const url = `${urlToUse}?search=${encodeURIComponent(search)}&limit=${this.limit}&offset=${this.offset}`;

    this.http.get<any>(url).subscribe({
      next: (data) => {
        const newOptions = data.results.map((item: any) => ({
          label: item.label || item.name,
          value: item.value || item.id,
        }));

        question.filteredOptions = reset
          ? newOptions
          : [...question.filteredOptions, ...newOptions];

        this.hasMoreOptions = !!data.next;
      },
      error: () => {
        question.filteredOptions = [];
      }
    });
  }

  onScrollDropdown(event: any, question: any) {
    const el = event.target;

    const atBottom =
      el.scrollHeight - el.scrollTop <= el.clientHeight + 10;

    if (atBottom && this.hasMoreOptions && !this.loadingMore) {
      this.loadingMore = true;

      this.offset += this.limit;

      this.fetchOptions(question);

      this.loadingMore = false;
    }
  }

  private configureQuestions(): void {

    this.questions.sort((a: any, b: any) => {
      const aPromotional = a.id?.startsWith('allow_promotional');
      const bPromotional = b.id?.startsWith('allow_promotional');

      if (aPromotional && !bPromotional) {
        return 1;
      }

      if (!aPromotional && bPromotional) {
        return -1;
      }

      return 0;
    });

    this.promotionalTitleShown = false;
    this.firstAllowPromotionalId = null;
    this.firstIncrementalId = null;

    this.questions.forEach((question: any) => {

      if (
        this.firstIncrementalId === null &&
        question.incremental_info === true
      ) {
        this.firstIncrementalId = question.id;
      }

      if (
        this.firstAllowPromotionalId === null &&
        question.id?.startsWith('allow_promotional')
      ) {
        this.firstAllowPromotionalId = question.id;
      }

      if (
        question.type === 'list-selection' &&
        Array.isArray(question.options)
      ) {
        question.options.sort((a: any, b: any) =>
          a.label.localeCompare(b.label)
        );
      }

      if (question.type === 'date') {

        const validators = [
          Validators.pattern(
            /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
          ),
          this.noFutureDateValidator,
        ];

        if (question.required) {
          validators.unshift(Validators.required);
        }

        question.formControl.setValidators(validators);
        question.formControl.updateValueAndValidity();
      }
    });

    this.questions.forEach((question: any) => {

      if (question.type === 'time') {
        question.formControl.setValidators([
          Validators.pattern(/^([01]\d|2[0-3]):([0-5]\d)$/)
        ]);

        question.formControl.updateValueAndValidity();
      }
    });

  }

}
